<template>
  <div class="payform d-flex justify-content-center">
    <div class="container">
      <form
          class="paymentForm"
          ref="form"
          @submit="createInvoice"
      >
        <div class="row payform__item-row">
          <div class="col wrapper payform__input qr__amount"
               :style="[validationErrors.amount ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('sum') }}</label>
            <input
                class="col-12 field"
                step="0.01" min="0"
                type="number"
                name="amount"
                v-model="amount"
                @keypress="validateAmount"
                @input="validate"
                @focusout="fillAmount"
            >
          </div>
          <div class="col wrapper payform__input">
            <label class="payform__input-label">{{ translate('currency') }}</label>
            <div class="select"
                 v-bind:class="{'is-active': isActiveSelect}"
            >
              <div class="select_header"
                   v-if="foreignCurrencyComputed === false"
              >
                <span class="select_current disabled-span">{{ currencyComputed }}</span>
              </div>
              <div class="select_header"
                   v-if="foreignCurrencyComputed === true"
                   @click="selectToggle"
              >
                <span class="select_current">{{ currencyComputed }}</span>
                <div class="select_icon"></div>
                <input
                    type="text"
                    hidden
                    name="currency"
                    v-model="currency"
                >
              </div>
              <div class="select_body">
                <div class="select_item"
                     v-for="item in currencyList"
                     :key="item"
                     @click="selectChoose">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.poName ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('poName') }}</label>
            <input type="text" name="poName"
                   v-model.trim="poName"
                   @input="validate"
                   class="col-12 field"
            >
          </div>
        </div>

        <div class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.email ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">email</label>
            <input type="email" name="email"
                   v-model.trim="email"
                   @input="validate"
                   class="col-11 field input_cc_email"
            >
            <b-link id="tooltip-email-link"
                    class="input_tooltip"
                    :style="{'color': siteBrandColor}"
            >?</b-link>
            <b-tooltip target="tooltip-email-link">{{ translate('tooltipText') }}</b-tooltip>
          </div>
        </div>

        <!--       Additional fields START -->

        <div v-if="merchantInfo.qrPageOptions.customer_name" class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.customerName ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('customerName') }}</label>
            <input type="text" name="customerName"
                   v-model.trim="customerName"
                   @input="validate"
                   class="col-12 field"
            >
          </div>
        </div>

        <div v-if="merchantInfo.qrPageOptions.customer_address" class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.customerAddress ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('customerAddress') }}</label>
            <input type="text" name="customerAddress"
                   v-model.trim="customerAddress"
                   @input="validate"
                   class="col-12 field"
            >
          </div>
        </div>

        <div v-if="merchantInfo.qrPageOptions.customer_phone" class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.customerPhone ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('customerPhone') }}</label>
            <masked-input type="tel" name="customerPhone"
                          mask="\+\3\7\5111111111"
                          v-model.trim="customerPhone"
                          @input="validate"
                          class="col-12 field"
            />
          </div>
        </div>

        <div v-if="merchantInfo.qrPageOptions.order_contract" class="row payform__item-row">
          <div class="col wrapper payform__input"
               :style="[validationErrors.orderContract ? {'border-bottom-color': 'red'} : {'border-bottom-color': '#CCCCCC'}]"
          >
            <label class="payform__input-label">{{ translate('orderContract') }}</label>
            <input type="text" name="orderContract"
                   v-model.trim="orderContract"
                   @input="validate"
                   class="col-12 field"
            >
          </div>
        </div>

        <!--       Additional fields END -->

        <div class="btn_group d-flex justify-content-end">
          <button type="submit" class="main_btn"
                  :style="cssButtonDisabled"
                  :disabled="submitDisabled === true"
          >
            {{ translate('submitText') }}
          </button>
        </div>
        <div class="error row d-flex justify-content-center"
             v-if="error"
        >{{ errorMessage }}
        </div>
      </form>
      <div hidden id="hiddenDiv"></div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Form',

  data() {
    return {
      defaultInputBorderColor: '#D6D6D6',
      errorMessage: '',
      error: false,
      validationErrors: {},
      amount: '',
      poName: '',
      email: '',
      customerName: '',
      customerAddress: '',
      customerPhone: '',
      orderContract: '',
      isActiveSelect: false,
      currency: '',
      submitDisabled: true,
      locale: {
        'russian': {
          sum: 'сумма',
          currency: 'валюта',
          poName: 'наименование товара/услуги',
          tooltipText: 'Адрес электронной почты нужен для отправки чека',
          submitText: 'Перейти к оплате',
          customerName: 'ФИО',
          customerAddress: 'АДРЕС',
          customerPhone: 'ТЕЛЕФОН',
          orderContract: 'НОМЕР ДОГОВОРА',
          serverError: 'Серверная ошибка. Пожалуйста, обратитесь в тех поддержку',
          maxAmount: 'Максимальная сумма',
          minAmount: 'Минимальная сумма',
        },
        'english': {
          sum: 'amount',
          currency: 'currency',
          poName: 'product/service name',
          tooltipText: 'A receipt will be sent to this email address',
          submitText: 'Go to the payment',
          customerName: 'NAME',
          customerAddress: 'ADDRESS',
          customerPhone: 'PHONE',
          orderContract: 'ORDER CONTRACT',
          serverError: 'Server error. Please contact technical support',
          maxAmount: 'Max amount',
          minAmount: 'Min amount',
        }
      },
    }
  },

  props: {
    apiPath: String,
    language: String,
    billingId: String,
    siteBrandColor: String,
    test: String,
    merchantInfo: Object
  },

  computed: {
    cssButtonDisabled() {
      if (this.submitDisabled) {
        return {
          'background-color': this.siteBrandColor + '77', // Полупрозрачный основной цвет
        }
      }
      return {
        'background-color': this.siteBrandColor,
      }
    },

    foreignCurrencyComputed: function () {
      return this.$parent.merchantInfo.foreignCurrency;
    },

    currencyListComputed: function () {
      return this.$parent.merchantInfo.currencyList;
    },

    currencyList: {
      get: function () {
        if (this.currencyListComputed) {
          return this.currencyListComputed;
        } else {
          return ['BYN'];
        }
      },
    },

    currencyComputed: {
      get: function () {
        if (this.foreignCurrencyComputed) {
          return this.currency
        } else {
          return 'BYN';
        }
      },
      set: function (newCurrency) {
        this.currency = newCurrency;
      }
    }
  },

  methods: {
    fillAmount: function () {
      if (this.amount !== '') {
        this.amount = Number.parseFloat(this.amount.replace(/,/, '.')).toFixed(2);
      }
    },

    clearError: function (e) {
      if (e && e.target) {
        const name = e.target.getAttribute('name');
        this.validationErrors[name] = false;
      }
    },

    validate: function () {
      this.submitDisabled = true;

      if (!this.amount) {
        // this.validationErrors.amount = true;
        return false;
      }
      if (this.currencyComputed.length < 2) {
        // this.validationErrors.currency = true;
        return false;
      }
      if (this.poName.length < 2) {
        // this.validationErrors.poName = true;
        return false;
      }
      if (!this.email) {
        // this.validationErrors.email = true;
        return false;
      }
      if (this.$parent.merchantInfo.qrPageOptions.customer_name && !this.customerName) {
        // this.validationErrors.customerName = true;
        return false;
      }
      if (this.$parent.merchantInfo.qrPageOptions.customer_address && !this.customerAddress) {
        // this.validationErrors.customerAddress = true;
        return false;
      }
      if (this.$parent.merchantInfo.qrPageOptions.customer_phone && !this.customerPhone) {
        // this.validationErrors.customerPhone = true;
        return false;
      }
      if (this.$parent.merchantInfo.qrPageOptions.order_contract && !this.orderContract) {
        // this.validationErrors.orderContract = true;
        return false;
      }

      this.submitDisabled = false;

      return true;
    },

    validateAmount: function (e) {
      /*Не пропускаем символы отличные от цифр точки и запятой*/
      if (!/^\d*\.?,?\d*$/.test(e.key)) {
        return false;
      }
    },

    selectChoose: function (e) {
      this.currency = e.target.innerText;
      this.selectToggle();
    },

    selectToggle: function () {
      this.isActiveSelect = !this.isActiveSelect;
    },

    createInvoice: function (e) {
      e.preventDefault();
      this.error = false;

      if (!this.validate()) {
        return;
      }

      this.$emit('submitting', true);
      const data = {
        siteId: this.billingId,
        email: this.email,
        poName: this.poName,
        shortName: this.poName,
        poTag: 'qr',
        currencyId: this.currencyComputed,
        languageId: this.language,
        gracePeriod: 1,
        username: this.customerName,
        address: this.customerAddress,
        phone: this.customerPhone,
        orderContract: this.orderContract,
        items: [
          {
            quantity: 1,
            productName: this.poName,
            priceBase: this.amount
          }
        ],
      };
      const formData = this.getFormData(data);
      this.$http.post(`${this.apiPath}/invoice/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(this.payment)
          .catch(this.parseError);
    },

    payment: function (response) {
      this.error = false;
      const data = {
        invoiceId: response.data.body.id,
        storeId: response.data.body.siteId,
        orderNum: response.data.body.poName,
        orderTag: response.data.body.poTag,
        orderContract: response.data.body.poContractNumber,
        languageId: response.data.body.languageId,
        currencyId: response.data.body.currencyId,
        items: response.data.body.invoiceItems,
        test: this.test,
        email: this.email,
        phone: this.customerPhone,
        customerName: this.customerName,
        customerAddress: this.customerAddress,
      };
      const formData = this.getFormData(data);
      this.$http.post(`${this.apiPath}/payments`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(this.redirect)
          .catch(this.parseError);
    },

    translate: function (key) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.locale[this.language].hasOwnProperty(key)) {
        return this.locale[this.language][key];
      }
      return key;
    },

    translateErrors: function (errors) {
      const translatedErrors = [];
      errors.forEach(error => {
        const [key, value] = error.split(':');
        if (value) {
          translatedErrors.push(this.translate(key) + ':' + value);
        } else {
          translatedErrors.push(this.translate(key));
        }
      });

      return translatedErrors;
    },

    parseError: function (error) {
      this.$emit('submitting', false);
      this.error = true;
      if (error.response.status === 500) {
        this.errorMessage = this.translate('serverError');
      } else {
        this.errorMessage = this.translateErrors(error.response.data.errors).join('; ');
      }
    },

    redirect: function (response) {
      window.location.href = response.data.body.paymentUrl;
    },

    getFormData: function (obj, form, namespace) {
      let fd = form || new FormData();
      let formKey;

      for (let property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property) && obj[property]) {
          if (namespace) {
            formKey = namespace + '[' + property + ']';
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File, use recursivity.
          if (obj[property] instanceof Date) {
            fd.append(formKey, obj[property].toISOString());
          } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
            this.getFormData(obj[property], fd, formKey);
          } else { // if it's a string or a File object
            fd.append(formKey, obj[property]);
          }
        }
      }

      return fd;
    }
  }
}
</script>

<style scoped>
/*.progress-div {*/
/*  background-color: var(--color);*/
/*}*/

/*.button-div {*/
/*  background-color: var(--color);*/
/*}*/

/*.btn {*/
/*  background-color: var(--color);*/
/*}*/

/*.select.is-active .select_header,*/
/*.payment_form_row input:focus {*/
/*  border-bottom-color: var(--color)*/
/*}*/
</style>
